import React from "react";
import { Button, Form, Modal } from "semantic-ui-react";
import { connect } from "react-redux";
import { socket } from "../../../lib/socketio";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC } from "../../../actions/headerActions";

const AppSettings = ({ addHeader }) => {
  const [open, setOpen] = React.useState(false);
  const [selectUrl, setSelectUrl] = React.useState();

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSaveClick = () => {
    socket.off();
    socket.disconnect();
    socket.close();
    setOpen(false);
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(" electron/") > -1) {
      const { app } = window.require("electron").remote;
      var fs = window.require("fs");
      let json_string = JSON.stringify({ url: selectUrl });
      fs.writeFileSync("customurl.json", json_string);
      app.relaunch();
      app.exit(0);
    }
  };

  const handleDropDownChange = (e, { type, value }) => {
    setSelectUrl(value);
  };

  return (
    <div style={styles.div}>
      <h1 style={styles.header}>Application Settings</h1>
      {addHeader ? <h4 style={styles.header}>{addHeader}</h4> : ""}
      <Modal
        trigger={<Button color="blue">Application Settings</Button>}
        style={{ width: "600px" }}
        open={open}
        size={"large"}
        onClose={handleClose}
        onOpen={handleOpen}
      >
        <Modal.Header>Application Settings</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Dropdown
                fluid
                search
                selection
                clearable
                lazyLoad
                label="Choose RMS IP:"
                name="contract_type_id"
                options={contract_types}
                value={selectUrl}
                onChange={handleDropDownChange}
              />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions style={{ marginLeft: "10px" }}>
          <Button
            color={"red"}
            size="small"
            id="1"
            content="Exit"
            onClick={handleClose}
          />
          <Button
            color={"blue"}
            size="small"
            id="2"
            content="Save Parameters"
            onClick={handleSaveClick}
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
};

const styles = {
  label: {
    float: "right",
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    marginBottom: "20px",
  },
};

const contract_types = [
  {
    key: 1,
    text: "Plant A (192.168.0.192) / Single Unit (If accessed from tech laptop)",
    value: "http://192.168.0.192:4001",
  },
  {
    key: 2,
    text: "Plant B (192.168.0.193)",
    value: "http://192.168.0.193:4001",
  },
  {
    key: 3,
    text: "Default (Defaults to the unit connected to this RMS PC)",
    value: "http://localhost:4001",
  },
];

const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppSettings);
